import { render } from "./AddCarPage.vue?vue&type=template&id=7fd38bc2"
import script from "./AddCarPage.vue?vue&type=script&lang=js"
export * from "./AddCarPage.vue?vue&type=script&lang=js"

import "./AddCarPage.vue?vue&type=style&index=0&id=7fd38bc2&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__